// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgExternalLink = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M12 14H2V4h5V2H1c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V9h-2z"
    />
    <path
      fill={props.color ?? 'currentColor'}
      d="M15.923.62c-.1-.25-.3-.44-.54-.54a1 1 0 0 0-.38-.08h-5.5c-.55 0-1 .45-1 1s.45 1 1 1h3.09l-4.8 4.79a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l4.79-4.79V6.5c0 .55.45 1 1 1s1-.45 1-1V1c0-.13-.03-.26-.08-.38"
    />
  </svg>
)
export default SvgExternalLink
